import { Component } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-empty-cart-disabled-method-dialog',
  templateUrl: './empty-cart-disabled-method-dialog.component.html',
  styleUrls: ['./empty-cart-disabled-method-dialog.component.scss'],
})
export class EmptyCartDisabledMethodDialogComponent {}
